import '../styles/Legal.css';

const TermsOfService = () => {
  return (
    <>
      <section className="legal-header">
        <div className="legal-title-container">
          <div className="legal-badge">
            <span>📜 Please Read Carefully</span>
          </div>
          <h1 className="legal-title">
            <span>Terms</span> of Service
          </h1>
          <div className="legal-effective">
            Effective Date: <strong>June 04, 2025</strong>
          </div>
        </div>
      </section>

      <section className="legal-content">
        <div className="legal-card">
          <div className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing or using the services provided by Oliveeb LLC ("Company," "we," "us," or "our"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree, you must not use our Services.</p>
          </div>

          <div className="legal-section">
            <h2>2. Eligibility</h2>
            <p>You must be at least 13 years old to use our Services. By using our platform, you represent that you meet this requirement.</p>
          </div>

          <div className="legal-section">
            <h2>3. Account Registration</h2>
            <p>To access certain features, you may need to create an account. You agree to:</p>
            <ul className="legal-list">
              <li>Provide accurate and complete information</li>
              <li>Keep your login credentials secure</li>
              <li>Notify us immediately of any unauthorized use</li>
            </ul>
            <p>You are responsible for all activities under your account.</p>
          </div>

          <div className="legal-section">
            <h2>4. Use of Services</h2>
            <p>You agree to use our Services only for lawful purposes. You must not:</p>
            <ul className="legal-list">
              <li>Violate any applicable laws or regulations</li>
              <li>Interfere with or disrupt the platform</li>
              <li>Attempt to gain unauthorized access to systems or data</li>
              <li>Use the Services for fraudulent or harmful activities</li>
            </ul>
            <div className="highlight-box">
              <p style={{ fontWeight: 600, marginBottom: 0 }}>⚖️ Always use our platform responsibly and respectfully.</p>
            </div>
          </div>

          <div className="legal-section">
            <h2>5. Payments and Subscriptions</h2>
            <p>If you purchase paid features:</p>
            <ul className="legal-list">
              <li>You agree to provide valid payment information</li>
              <li>Fees are billed as stated at the time of purchase</li>
              <li>Subscriptions may renew automatically unless canceled</li>
              <li>All payments are non-refundable unless stated otherwise</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>6. Intellectual Property</h2>
            <p>All content, trademarks, and materials on the platform are owned by Oliveeb LLC or its licensors. You may not:</p>
            <ul className="legal-list">
              <li>Copy, modify, or distribute content without permission</li>
              <li>Use our branding without authorization</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>7. User Content</h2>
            <p>If you submit or upload content:</p>
            <ul className="legal-list">
              <li>You retain ownership of your content</li>
              <li>You grant us a license to use, store, and display it to provide Services</li>
              <li>You are responsible for ensuring your content does not violate any laws or rights</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>8. Privacy</h2>
            <p>Your use of our Services is also governed by our <a href="/privacy-policy.html">Privacy Policy</a>.</p>
          </div>

          <div className="legal-section">
            <h2>9. Termination</h2>
            <p>We may suspend or terminate your access at any time if you:</p>
            <ul className="legal-list">
              <li>Violate these Terms</li>
              <li>Engage in harmful or unlawful behavior</li>
            </ul>
            <p>You may stop using our Services at any time.</p>
          </div>

          <div className="legal-section">
            <h2>10. Disclaimer of Warranties</h2>
            <p>Our Services are provided "as is" and "as available." We do not guarantee:</p>
            <ul className="legal-list">
              <li>That the Services will be uninterrupted or error-free</li>
              <li>That any defects will be corrected</li>
              <li>The accuracy or reliability of any content</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>11. Limitation of Liability</h2>
            <p>To the fullest extent permitted by law, Oliveeb LLC shall not be liable for:</p>
            <ul className="legal-list">
              <li>Indirect, incidental, or consequential damages</li>
              <li>Loss of data, profits, or business opportunities</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>12. Indemnification</h2>
            <p>You agree to defend and indemnify Oliveeb LLC from any claims, damages, or expenses arising from your use of the Services or violation of these Terms.</p>
          </div>

          <div className="legal-section">
            <h2>13. Changes to Terms</h2>
            <p>We may update these Terms from time to time. Changes will be posted with an updated effective date.</p>
          </div>

          <div className="legal-section">
            <h2>14. Governing Law</h2>
            <p>These Terms shall be governed by applicable laws.</p>
          </div>

          <div className="legal-section">
            <h2>15. Contact Information</h2>
            <div className="contact-block">
              <div className="contact-info">
                <strong>Oliveeb LLC</strong>
                <span>Email: <a href="mailto:admin@oliveeb.com">admin@oliveeb.com</a></span>
                <span>Website: <a href="https://www.oliveeb.com" target="_blank">www.oliveeb.com</a></span>
              </div>
              <a className="contact-badge" href="/contact-us.html">We're here to help 💬</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfService;